import { RouteObject } from 'react-router-dom';
import NoAccess from './pages/errors/NoAccess';
import PageNotFound from './pages/errors/PageNotFound';

const routes: RouteObject[] = [
  {
    path: 'no-access',
    element: <NoAccess />,
  },
  {
    path: 'not-found',
    element: <PageNotFound />,
  },
];

export default routes;
